import React from 'react';
import { motion } from 'framer-motion';
export function ImpactShowcase() {
  return <section className="py-20 px-4 bg-[#fdf8f3] overflow-hidden pt-[20px] pb-[20px]" data-id="element-172" data-mp="39ka9lomziin">
      <div className="max-w-5xl mx-auto text-center" data-id="element-173" data-mp="3lntio5ptk7a9">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12" data-id="element-174" data-mp="3lp4nm8v03l2y">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-6 tracking-tight uppercase leading-tight" data-id="element-175" data-mp="m8y8wgxb9hfh">
            TRANSFORMÁ LO ORDINARIO <br data-id="element-176" data-mp="88nbsw5er6lv" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d97706] to-[#92400e]" data-id="element-177" data-mp="8b9iyuodzk3k">
              EN ALGO EXTRAORDINARIO
            </span>
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="relative rounded-[2rem] overflow-hidden shadow-[0_20px_50px_rgba(146,64,14,0.15)] border border-gray-200" data-id="element-178" data-mp="2t1igiqmkdybc">
          <img src="https://cdn.magicpatterns.com/uploads/hT1baz4vx2oScfbEvdhdTf/imagen_de_antes_y_despues.webp" alt="Transformación de mesa normal a mesa con resina epóxica" className="w-full h-auto object-cover" data-id="element-179" data-mp="luonv1s558m8" />
        </motion.div>
      </div>
    </section>;
}